import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { withInterceptorsFromDi, provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './app/interceptors/http-request-interceptor';
import { ScriptingComponent } from './app/components/scripting/scripting.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { GuidExpired } from './app/components/guid-expired/guid-expired.component';
import { WhatNextComponent } from './app/components/what-next/what-next.component';
import { GuidInvalid } from './app/components/guid-invalid/guid-invalid.component';
import { GuidClosed } from './app/components/guid-closed/guid-closed.component';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { LogoutComponent } from './app/components/logout/logout.component';
import { GuidBase } from './app/components/guid-base/guid-base.component';
import { LoginComponent } from './app/components/login/login.component';
import { MSALInstanceFactory } from './app/auth/msal-instance-factory';
import { RootComponent } from './app/components/root/root.component';
import { HomeComponent } from './app/components/home/home.component';
import { InteractionType, LogLevel } from '@azure/msal-browser';
import { Error } from './app/components/error/error.component';
import { ValidGuidGuard } from './app/guards/valid-guid.guard';
import { environment } from './environments/environment';
import { provideRouter, Routes } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { provideToastr } from 'ngx-toastr';
import { Router } from '@angular/router';

const routes: Routes = [
    //Guid Validation Routes
    { path: '', redirectTo: '/65D1A040-7AB6-43A6-8B62-03AD630A34D0/login', pathMatch: 'full' },
    { path: ':guid/login', component: LoginComponent, canActivate: [ValidGuidGuard] },
    { path: ':guid/expired', component: GuidExpired },
    { path: ':guid/closed', component: GuidClosed },
    { path: ':guid/invalid', component: GuidInvalid },
    { path: ':guid/landing', component: GuidBase },

    //Login logout pages
    { path: 'logout', component: LogoutComponent },

    //{ path: 'load/:claimReference', component: LoadComponent },
    { path: 'home/:claimReference', component: HomeComponent, canActivate: [MsalGuard] },

    //Form routes
    {
        path: 'form', component: RootComponent, canActivate: [MsalGuard], children: [
            { path: 'Personal', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'Employment', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'YourAccidentYourInvolvement', component: RootComponent, canActivate: [MsalGuard]},
            { path: 'YourAccidentTimeLocation', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'YourAccidentDescription', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'YourInjuriesDetails', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'YourInjuriesMedicalAttention', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'YourVehicle', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'ResponsibleParty', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'Passengers', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'PoliceAndWitnesses', component: RootComponent, canActivate: [MsalGuard] },
            { path: 'Summary', component: RootComponent, canActivate: [MsalGuard] }
        ]
    },

    //Scripting and "What's Next" routes
    { path: 'scripting', component: ScriptingComponent, canActivate: [MsalGuard] },
    { path: 'whats-next', component: WhatNextComponent, canActivate: [MsalGuard] },

    //Error
    { path: 'error', component: Error },

    //Wildcard route for unknown paths
    { path: '**', redirectTo: `/${environment.defaultGuid}/login`, pathMatch: 'full' },
];

export function loggerCallback(logLevel: LogLevel, message: string) {
    //console.log(message);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...environment.apiConfig.scopes]
        },
        loginFailedRoute: `/${environment.defaultGuid}/login`
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();

    protectedResourceMap.set('/staticdata', environment.apiConfig.scopes);
    protectedResourceMap.set('/claims', environment.apiConfig.scopes);
    protectedResourceMap.set('/customer', environment.apiConfig.scopes);
    protectedResourceMap.set('/postcodelookup', environment.apiConfig.scopes);
    protectedResourceMap.set('/contactvalidation', environment.apiConfig.scopes);
    protectedResourceMap.set('/vehicledata', environment.apiConfig.scopes);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule),
        provideAnimationsAsync(),
        provideRouter(routes),
        provideToastr(),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: (router: Router) =>
                MSALInstanceFactory(router),
            deps: [Router]
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService
    ]
}).catch(err => console.error(err));
